﻿

	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    export class EventSearchFilter extends SearchFilter {
        
    }
